import { REQUEST_MONTHLY_ORDER_DELIVERY, REQUEST_MONTHLY_ORDER_DELIVERY_FAILURE, REQUEST_MONTHLY_ORDER_DELIVERY_SUCCESS } from "../../constant/DashboardConstant";

const initialState = {
  monthlyOrdeDelivery: {
    data: [],
  },
};

export const monthlyOrderDeliveryOrderReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case REQUEST_MONTHLY_ORDER_DELIVERY:
      return {
        ...state,
        monthlyOrdeDelivery: {
          data: [],
          status: 'fetching',
          isLoading: true,
        },
      };
    case REQUEST_MONTHLY_ORDER_DELIVERY_SUCCESS:
      return {
        ...state,
        monthlyOrdeDelivery: {
          data: payload,
          status: 'ready',
          isLoading: false,
        },
      };
    case REQUEST_MONTHLY_ORDER_DELIVERY_FAILURE:
      return {
        ...state,
        monthlyOrdeDelivery: {
          data: [],
          status: 'failure',
          isLoading: false,
        },
      };
    default:
      return state;
  }
}
